export default {
  YY: 'year',
  YYYY: 'year',
  M: 'month',
  MM: 'month',
  MMM: 'month',
  MMMM: 'month',
  D: 'day',
  DD: 'day',
  d: 'day',
  dd: 'day-name',
  ddd: 'day-name',
  dddd: 'day-name',
  H: 'hour',
  HH: 'hour',
  h: 'hour',
  hh: 'hour',
  a: 'meridiem',
  A: 'meridiem',
  m: 'minute',
  mm: 'minute',
  s: 'second',
  ss: 'second',
  SSS: 'second'
}
